/***************************************************************
5/22/2017
Alexander Self
Inputs
- Different form inputs
***************************************************************/
import React from 'react';
const $ = window.$;


export function DatePicker({ id, label, min, max, disabled, required }) {
  if (required) {
    return (
      <div>
        <label htmlFor={id}>{label}</label>
        <input type="date" id={id} disabled={disabled} min={min} max={max} required />
      </div>
    );
  }
  return (
    <div>
      <label htmlFor={id}>{label}</label>
      <input type="date" id={id} disabled={disabled} min={min} max={max} />
    </div>
  );
}

export function TimePicker({ id, label, required, onChange }) {
  if (required) {
    return (
      <div>
        <label htmlFor={id}>{label}</label>
        <input id={id} type="time" required onChange={onChange} />
      </div>
    )
  }
  return (
    <div>
      <label htmlFor={id}>{label}</label>
      <input id={id} type="time" onChange={onChange} />
    </div>
  )
}

export function TextInput({ id, label, defaultValue, placeholder, onChange, required }) {
  if (required) {
    return (
      <div>
        <label>{label}</label>
        <input id={id} type="text" defaultValue={defaultValue} placeholder={placeholder} onChange={onChange} required />
      </div>
    )
  }
  return (
    <div>
      <label>{label}</label>
      <input id={id} type="text" defaultValue={defaultValue} placeholder={placeholder} onChange={onChange} />
    </div>
  );
}

export function NumberInput({ id, label, min, max, step, value, onChange, onBlur, defaultValue, placeholder, disabled, required }) {
  if (required) {
    return (
      <div>
        <label>{label}</label>
        <input id={id} type="number" min={min} max={max} step={step} value={value} onChange={onChange} onBlur={onBlur}
          defaultValue={defaultValue} placeholder={placeholder} disabled={disabled} required
        />
      </div>
    );
  }
  return (
    <div>
      <label>{label}</label>
      <input id={id} type="number" min={min} max={max} step={step} value={value} onChange={onChange} onBlur={onBlur}
        defaultValue={defaultValue} placeholder={placeholder} disabled={disabled}
      />
    </div>
  );
}

export function Select({ id, opts, label, onChange, required, disabled }) {
  if (required) {
    $(document).ready(() => {
      $(`#${id}`).material_select();
    });
    return (
      <div>
        <label>{label}</label>
        <select id={id} className="browser-default" onChange={onChange} required disabled={disabled}>
          <option value=""></option>
          {
            opts.map((opt) => (
              <option id={opt.label} key={opt.val} value={opt.val}>{opt.label}</option>
            ))
          }
        </select>
      </div>
    )
  }
  $(document).ready(() => {
    $(`#${id}`).material_select();
  });
  return (
    <div>
      <label>{label}</label>
      <select id={id} className="browser-default" onChange={onChange} disabled={disabled}>
        <option value=""></option>
        {
          opts.map((opt) => (
            <option id={opt.label} key={opt.val} value={opt.val}>{opt.label}</option>
          ))
        }
      </select>
    </div>
  )
}
/* Specifically for the fields
  Set selected as true for default value
*/
export function SelectField({ id, opts, label, onChange, selected, defaultValue }) {
  $(document).ready(() => {
    $(`#${id}`).material_select();
  });
  return (
    <div>
      <label>{label}</label>
      <select id={id} className="browser-default" onChange={onChange}>
        <option value=""></option>
        {
          opts.map((opt) => {
            if (selected && opt.field === defaultValue) {
              return (
                <option key={opt.field} value={opt.field} selected>{opt.field}</option>
              )
            }
            return (
              <option key={opt.field} value={opt.field}>{opt.field}</option>
            )
          })
        }
      </select>
    </div>
  )
}
/* Specifically for the fields */
export function SelectBlock({ id, opts, label }) {
  $(document).ready(() => {
    $(`#${id}`).material_select();
  });
  return (
    <div>
      <label>{label}</label>
      <select id={id} className="browser-default">
        <option defaultValue=""></option>
        {
          opts.map((opt) => (
            <option key={opt.block} value={opt.block}>{opt.block}</option>
          ))
        }
      </select>
    </div>
  )
}
/* Specifically for the fields
  Set selected as true for default value
*/
export function SelectChemical({ id, opts, label, onChange, selected, defaultValue }) {
  $(document).ready(() => {
    $(`#${id}`).material_select();
  });
  return (
    <div>
      <label>{label}</label>
      <select id={id} className="browser-default" onChange={onChange}>
        <option value=""></option>
        {
          opts.map((opt) => {
            if (selected && opt.name === defaultValue) {
              return (
                <option key={opt.name} value={opt.id} selected>{opt.name}</option>
              )
            }
            return (
              <option key={opt.name} value={opt.id}>{opt.name}</option>
            )
          })
        }
      </select>
    </div>
  )
}
/* Specifically for the equipment */
export function SelectEquipment({ id, opts, label }) {
  $(document).ready(() => {
    $(`#${id}`).material_select();
  });
  return (
    <div>
      <label>{label}</label>
      <select id={id} className="browser-default">
        <option defaultValue=""></option>
        {
          opts.map((opt) => (
            <option key={opt.equipmentNo} value={opt.equipmentNo}>{opt.equipmentNo} - {opt.description} ({opt.companyCode})</option>
          ))
        }
      </select>
    </div>
  )
}
export function MultiSelect({ id, opts, label, onChange, required, disabled }) {
  if (required) {
    $(document).ready(() => {
      $(`#${id}`).material_select();
    });
    return (
      <div className="input-field">

        <select multiple id={id} onChange={onChange} required disabled={disabled}>
          <option value=""></option>
          {
            opts.map((opt) => (
              <option id={opt.label} key={opt.val} value={opt.val}>{opt.label}</option>
            ))
          }
        </select>
        <label>{label}</label>
      </div>
    )
  }
  $(document).ready(() => {
    $(`#${id}`).material_select();
  });
  return (
    <div className="input-field">

      <select multiple id={id} onChange={onChange} disabled={disabled}>
        <option value=""></option>
        {
          opts.map((opt) => (
            <option id={opt.label} key={opt.val} value={opt.val}>{opt.label}</option>
          ))
        }
      </select>
      <label>{label}</label>
    </div>
  )
}
export function Textarea({ id, label }) {
  $(document).ready(function() {
    $(`textarea#${id}`).characterCounter();
  });
  return (
    <div>
      <label htmlFor={id}>{label}</label>
      <textarea id={id} className="materialize-textarea" data-length="350"></textarea>
    </div>
  )
}

/* Materialze autocomplete: pass in onComplete callback to get value + id */
export function AutoComplete({ id, label, data, onComplete, onBlur, disabled }) {
  $(document).ready(() => {
    $(`#${id}`).autocomplete({
      data: data,
      limit: 10,
      minLength: 1,
      onAutocomplete: (val) => {
        onComplete(val, id);
      }
    });
  });
  return (
    <div>
      <label htmlFor={id}>{label}</label>
      <input type="text" id={id} className="autocomplete" onBlur={onBlur} disabled={disabled} />
    </div>
  )
}
/* Basic file button */
export function FileButton({ id, name, label, _class }) {
  return (
    <div className="file-field input-field">
      <div className="btn btn-flat">
        <span className={_class}>{label}</span>
        <input id={id} name={name} type="file"  />
      </div>
      <div className="file-path-wrapper">
        <input id={`file-path-${id}`} className="file-path validate" type="text" />
      </div>
    </div>
  )
}

export function RadioButton({ id, name, label, value, disabled, onClick, checked }) {
  if (checked) {
    return (
      <div>
        <input id={id} name={name} type="radio" disabled={disabled} onClick={onClick} value={value} defaultChecked />
        <label htmlFor={id}>{label}</label>
      </div>
    )
  }
  return (
    <div>
      <input id={id} name={name} type="radio" disabled={disabled} onClick={onClick} value={value} />
      <label htmlFor={id}>{label}</label>
    </div>
  )
}

export function CheckBox({ id, name, label, disabled, value, onChange }) {
  return (
    <div>
      <input id={id} name={name} type="checkbox" value={value} disabled={disabled} onChange={onChange} />
      <label htmlFor={id}>{label}</label>
    </div>
  )
}

export function Switch({ id, name, label, disabled, onClick, onChange, switchLabel1, switchLabel2, value }) {
  return (
    <div className="switch">
      <label>
        { switchLabel1 }
        <input type="checkbox" onClick={onClick} onChange={onChange} value={value} />
        <span className="lever"></span>
        { switchLabel2 }
      </label>
    </div>
  )
}

export function HiddenInput({ id, value }) {
  return (
    <div>
      <input id={id} type="hidden" value={value} />
    </div>
  );
}



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/inputs.js